import _typeof from '@babel/runtime/helpers/typeof';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { useState, useMemo } from 'react';
import { Accordion as Accordion$2 } from './Accordion.style.js';
import AccordionContext from './AccordionContext.js';
import { jsx } from 'react/jsx-runtime';
import useEffectOnce from '../../hooks/useEffectOnce.js';

var _excluded = ["children", "oneAtATime"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var Accordion = function Accordion(_ref) {
  var children = _ref.children,
    _ref$oneAtATime = _ref.oneAtATime,
    oneAtATime = _ref$oneAtATime === void 0 ? false : _ref$oneAtATime,
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    openIndices = _useState2[0],
    setOpenIndices = _useState2[1];
  useEffectOnce(function () {
    var initiallyOpenItems = React.Children.map(children, function (child, index) {
      var _child$props;
      return child !== null && child !== void 0 && (_child$props = child.props) !== null && _child$props !== void 0 && _child$props.initiallyExpanded ? index : null;
    }).filter(function (x) {
      return x !== null;
    });
    if (initiallyOpenItems.length > 0) {
      setOpenIndices(oneAtATime ? [initiallyOpenItems[0]] : initiallyOpenItems);
    }
  });
  var value = useMemo(function () {
    var toggleAccordion = function toggleAccordion(index) {
      var isOpen = openIndices.indexOf(index) !== -1;
      if (isOpen) {
        var newOpenIndices = _toConsumableArray(openIndices).filter(function (i) {
          return i !== index;
        });
        setOpenIndices(newOpenIndices);
      } else if (oneAtATime) {
        setOpenIndices([index]);
      } else {
        setOpenIndices([].concat(_toConsumableArray(openIndices), [index]));
      }
    };
    return {
      openIndices: openIndices,
      toggleAccordion: toggleAccordion
    };
  }, [openIndices, oneAtATime]);
  return /*#__PURE__*/jsx(AccordionContext.Provider, {
    value: value,
    children: /*#__PURE__*/jsx(Accordion$2, _objectSpread(_objectSpread({}, rest), {}, {
      children: React.Children.map(children, function (child, index) {
        return /*#__PURE__*/React.isValidElement(child) && /*#__PURE__*/React.cloneElement(child, _objectSpread(_objectSpread({}, _typeof(child.props) === 'object' ? child.props : {}), {}, {
          index: index,
          initiallyExpanded: undefined
        }));
      })
    }))
  });
};
var Accordion$1 = Accordion;

export { Accordion$1 as default };
//# sourceMappingURL=Accordion.js.map
